import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { AppService } from '../../app.service';
import { Observable } from 'rxjs';
import { of, BehaviorSubject } from 'rxjs';
import * as signalR from '@microsoft/signalr';

@Injectable({
    providedIn: 'root'
})

export class ReportsService {

    public _baseUrl: string = '';
    private notificationMetricsHubConnection!: signalR.HubConnection;
    private paymentsHubConnection!: signalR.HubConnection;

    public constructor(public appService: AppService,
                       public http: HttpClient,
                       @Inject('API_BASE_URL') baseurl: string) {

        this._baseUrl = baseurl;
    }

    public getBaseUrl = (): string => {

        return this._baseUrl;
    }

    public getMonthlyBillingReportFile = (searchParameters: any): Observable<any> => {

        let result: BehaviorSubject<any> = new BehaviorSubject<any>(null);
        const apipath: string = 'billing/GetInvoicesByYearMonth?year=' + searchParameters.Year + '&month=' + searchParameters.Month;
        const fullPath: string = this._baseUrl + apipath;
        const options = this.appService.getHttpHeaderOptions();

        options.responseType = "blob";

        this.http.get<any>(fullPath, options).subscribe((response: any) => {

            result.next(response);
            result.complete();

        }, error => {

            result.next(error);
        });

        return result;
    }

    public getDefaultNotificationMetricsSearchParameters = (): Observable<any> => {

        let result: BehaviorSubject<any> = new BehaviorSubject<any>(null);
        const apipath: string = 'Reports/GetDefaultNotificationMetricsSearchParameters';
        const fullPath: string = this._baseUrl + apipath
        const options = this.appService.getHttpHeaderOptions();

        this.http.get<any>(fullPath, options).subscribe((response: any) => {

            result.next(response);
            result.complete();

        }, error => {

            result.next(error);
        });

        return result;
    }

    public queueNotificationMetricsReport = (searchParameters: any): Observable<any> => {

        let result: BehaviorSubject<any> = new BehaviorSubject<any>(null);
        const apipath: string = 'Reports/QueueNotificationMetricsReport';
        const fullPath: string = this._baseUrl + apipath
        const options = this.appService.getHttpHeaderOptions();

        this.http.post<any>(fullPath, searchParameters, options).subscribe((response: any) => {

            result.next(response);
            result.complete();

        }, error => {

            result.next(error);
        });

        return result;
    }

    public runNotificationMetricsReport = (notificationMetricsRunId: number): Observable<any> => {

        let result: BehaviorSubject<any> = new BehaviorSubject<any>(null);
        const apipath: string = 'Reports/RunNotificationMetricsReport/' + notificationMetricsRunId;
        const fullPath: string = this._baseUrl + apipath
        const options = this.appService.getHttpHeaderOptions();

        this.http.get<any>(fullPath, options).subscribe((response: any) => {

            result.next(response);
            result.complete();

        }, error => {

            result.next(error);
        });

        return result;
    }

    public listAvailableNotificationMetricsRuns = (): Observable<any> => {

        let result: BehaviorSubject<any> = new BehaviorSubject<any>(null);
        const apipath: string = 'Reports/ListAvailableNotificationMetricsRuns';
        const fullPath: string = this._baseUrl + apipath
        const options = this.appService.getHttpHeaderOptions();

        this.http.get<any>(fullPath, options).subscribe((response: any) => {

            result.next(response);
            result.complete();

        }, error => {

            result.next(error);
        });

        return result;
    }

    public downloadNotificationMetricsReport = (notificationMetricsReportId: number): Observable<Blob | null> => {

        let result: BehaviorSubject<Blob | null> = new BehaviorSubject<Blob | null>(null);
        const apipath = `Reports/DownloadNotificationMetricsReport/${notificationMetricsReportId}`;
        const fullPath = this._baseUrl + apipath;
        const options = {...this.appService.getHttpHeaderOptions(), responseType: 'blob' as 'json' };

        this.http.get(fullPath, options).subscribe((blob: any) => {

            result.next(blob);
            result.complete();

        }, error => {

            result.next(error);
        });

        return result;
    }

    public requestNotificationMetricsRunCancellation = (notificationMetricsReportId: number): Observable<any> => {

        let result: BehaviorSubject<any> = new BehaviorSubject<any>(null);
        const apipath: string = 'Reports/RequestNotificationMetricsRunCancellation/' + notificationMetricsReportId;
        const fullPath: string = this._baseUrl + apipath;
        const options = this.appService.getHttpHeaderOptions();

        this.http.get<any>(fullPath, options).subscribe((response: any) => {

            result.next(response);
            result.complete();

        }, error => {

            result.next(error);
        });

        return result;
    }

    public startNotificationMetricsProgressConnection(notificationMetricsRunId: string): void {

        const baseUrlNoSlash: string = this._baseUrl.replace(/\/+$/, '');
        const signalREndpointFullPath: string = `${baseUrlNoSlash}/hubs/notificationmetricsreporthub?notificationMetricsRunId=${notificationMetricsRunId}`;

        this.notificationMetricsHubConnection = new signalR.HubConnectionBuilder().withUrl(signalREndpointFullPath).withAutomaticReconnect().build();

        this.notificationMetricsHubConnection.start().then(() => console.log('SignalR connection started')).catch(err => console.error('SignalR connection error:', err));
    }

    public onNotificationMetricsHubProgress(callback: (message: string) => void): void {

        try {

            this.notificationMetricsHubConnection.on('ReceiveProgress', (message: string) => {

                console.log('Progress message received:', message);
                callback(message);
            });

        } catch (e) {

            console.error('Error setting up ReceiveProgress handler:', e);
        }
    }

    public stopNotificationMetricsProgressConnection() {

        if (this.notificationMetricsHubConnection && this.notificationMetricsHubConnection.state === signalR.HubConnectionState.Connected) {

            this.notificationMetricsHubConnection.stop().then(() => {

                console.log('SignalR connection stopped');

                this.notificationMetricsHubConnection = undefined!;
            }).catch(err =>

                console.error('Error stopping SignalR:', err
            ));
        }
    }

    public getDefaultPaymentsSearchParameters = (): Observable<any> => {

        let result: BehaviorSubject<any> = new BehaviorSubject<any>(null);
        const apipath: string = 'Reports/GetDefaultPaymentsSearchParameters';
        const fullPath: string = this._baseUrl + apipath
        const options = this.appService.getHttpHeaderOptions();

        this.http.get<any>(fullPath, options).subscribe((response: any) => {

            result.next(response);
            result.complete();

        }, error => {

            result.next(error);
        });

        return result;
    }

    public queuePaymentsReport = (searchParameters: any): Observable<any> => {

        let result: BehaviorSubject<any> = new BehaviorSubject<any>(null);
        const apipath: string = 'Reports/QueuePaymentsReport';
        const fullPath: string = this._baseUrl + apipath;
        const options = this.appService.getHttpHeaderOptions();

        this.http.post<any>(fullPath, searchParameters, options).subscribe((response: any) => {

            result.next(response);
            result.complete();

        }, error => {

            result.next(error);
        });

        return result;
    }

    public runPaymentsReport = (paymentsRunId: number): Observable<any> => {

        let result: BehaviorSubject<any> = new BehaviorSubject<any>(null);
        const apipath: string = 'Reports/RunPaymentsReport/' + paymentsRunId;
        const fullPath: string = this._baseUrl + apipath;
        const options = this.appService.getHttpHeaderOptions();

        this.http.get<any>(fullPath, options).subscribe((response: any) => {

            result.next(response);
            result.complete();

        }, error => {

            result.next(error);
        });

        return result;
    }

    public listAvailablePaymentsRuns = (): Observable<any> => {

        let result: BehaviorSubject<any> = new BehaviorSubject<any>(null);
        const apipath: string = 'Reports/ListAvailablePaymentsRuns';
        const fullPath: string = this._baseUrl + apipath;
        const options = this.appService.getHttpHeaderOptions();

        this.http.get<any>(fullPath, options).subscribe((response: any) => {

            result.next(response);
            result.complete();

        }, error => {

            result.next(error);
        });

        return result;
    }

    public downloadPaymentsReport = (paymentsReportId: number): Observable<Blob | null> => {

        let result: BehaviorSubject<Blob | null> = new BehaviorSubject<Blob | null>(null);
        const apipath = `Reports/DownloadPaymentsReport/${paymentsReportId}`;
        const fullPath = this._baseUrl + apipath;
        const options = { ...this.appService.getHttpHeaderOptions(), responseType: 'blob' as 'json' };

        this.http.get(fullPath, options).subscribe((blob: any) => {

            result.next(blob);
            result.complete();

        }, error => {

            result.next(error);
        });

        return result;
    }

    public requestPaymentsRunCancellation = (paymentsReportId: number): Observable<any> => {

        let result: BehaviorSubject<any> = new BehaviorSubject<any>(null);
        const apipath: string = 'Reports/RequestPaymentsRunCancellation/' + paymentsReportId;
        const fullPath: string = this._baseUrl + apipath;
        const options = this.appService.getHttpHeaderOptions();

        this.http.get<any>(fullPath, options).subscribe((response: any) => {

            result.next(response);
            result.complete();

        }, error => {

            result.next(error);
        });

        return result;
    }

    public startPaymentsProgressConnection(paymentsRunId: string): void {

        const baseUrlNoSlash: string = this._baseUrl.replace(/\/+$/, '');
        const signalREndpointFullPath: string = `${baseUrlNoSlash}/hubs/paymentsreporthub?paymentsRunId=${paymentsRunId}`;

        this.paymentsHubConnection = new signalR.HubConnectionBuilder().withUrl(signalREndpointFullPath).withAutomaticReconnect().build();

        this.paymentsHubConnection.start().then(() => console.log('SignalR connection started')).catch(err => console.error('SignalR connection error:', err));
    }

    public onPaymentsHubProgress(callback: (message: string) => void): void {

        try {

            this.paymentsHubConnection.on('ReceiveProgress', (message: string) => {

                console.log('Progress message received:', message);
                callback(message);
            });

        } catch (e) {

            console.error('Error setting up ReceiveProgress handler:', e);
        }
    }

    public stopPaymentsProgressConnection() {

        if (this.paymentsHubConnection && this.paymentsHubConnection.state === signalR.HubConnectionState.Connected) {

            this.paymentsHubConnection.stop().then(() => {

                console.log('SignalR connection stopped');
                this.paymentsHubConnection = undefined!;

            }).catch(err =>

                console.error('Error stopping SignalR:', err)
            );
        }
    }
}
